import React from 'react';
import { UIWhiteBox } from "../UIContainer";
import './Overlay.scss';
import { dispatch, listen, unlisten } from '../../dispatcher/Dispatcher';
import OverlayEvent from '../../events/OverlayEvent';
import NextFrame from '../../util/NextFrame';

export interface IOverlayProps{
    data:OverlayData;
}

export interface IOverlayDetails{
    title?:string;
    className?:string;
    content:JSX.Element;
    maxWidth?:number;
    noPadding?:boolean;
    onBGClick?:()=>void;
}




export default class Overlay extends React.Component<IOverlayProps>{

    static show=($id:string, $details:IOverlayDetails)=>{
        OverlayManager.showOverlay($id, $details);
        return ()=>{
            OverlayManager.hideOverlay($id);
        }
    }
    static hide=($id:string)=>{
        OverlayManager.hideOverlay($id);
    }
    
    render(){
        
        let cn:string = "overlay "+this.props.data.state;

        let numOpacity:number=0;

        const {content, title, maxWidth, className, noPadding, onBGClick} = this.props.data.details as IOverlayDetails;

        if(className) cn+=" "+className;

        switch(this.props.data.state){
            case OverlayManager.STATE_SHOW:
                numOpacity=1;
            break;
            case OverlayManager.STATE_HIDE:

            break;
        }

        let overlayStyle:React.CSSProperties = {

        }
        

        return (
            <div className={cn} style={overlayStyle}>
                <div style={{opacity:numOpacity, transition:"all "+OverlayManager.TRANS_SPEED+"s"}} className="overlayBG" onClick={onBGClick}/>
                <UIWhiteBox flex={{style:{maxWidth:maxWidth}}} noPadding={noPadding} animateIntro>
                    {content}
                </UIWhiteBox>
            </div>
        );
    }

}




export interface IOverlayManagerProps {

}

export interface OverlayData{
    id:string;
    details:any;
    state?:string;
    replaceLast?:boolean;
}

export class OverlayManager extends React.Component<IOverlayManagerProps> {
    
    static STATE_INIT:string = "init";
    static STATE_SHOW:string = "show";
    static STATE_HIDE:string = "hide";

    static showOverlay($id:string, $details:any){
        dispatch(OverlayEvent.SHOW, {id:$id, details:$details})
    }
    static hideOverlay($id:string){
        dispatch(OverlayEvent.HIDE, {id:$id});
    }

    static TRANS_SPEED:number = 0.4;

    overlays:OverlayData[] = [];

    constructor(props: IOverlayManagerProps) {
        super(props);

        this.state = {

        }
    }
    
    componentDidMount(){
        listen(OverlayEvent.SHOW, this._onShow);
        listen(OverlayEvent.HIDE, this._onHide);
    }
    componentWillUnmount(){
        unlisten(OverlayEvent.SHOW, this._onShow);
        unlisten(OverlayEvent.HIDE, this._onHide);
    }


    _onShow=($event:OverlayEvent)=>{
        if($event.data){

            $event.data.state=OverlayManager.STATE_INIT;
            this.overlays.push($event.data);
        
            this.forceUpdate(()=>{
                NextFrame(()=>{
                    if($event.data){
                        $event.data.state=OverlayManager.STATE_SHOW;
                        this.forceUpdate();
                    }
                });
            });  
    
        }
    }

    _onHide=($event:OverlayEvent)=>{
        
        const findIndex = ()=>{           
            return this.overlays.findIndex(($overlay)=>{
                return $overlay.id===$event.data!.id;
            });
        }
        let index:number = findIndex();
        if(index!==-1){
            this.overlays[index].state = OverlayManager.STATE_HIDE;
            this.forceUpdate();
            window.setTimeout(()=>{
                let removeIndex:number = findIndex();//in case during transition the index changes
                if(removeIndex!==-1){
                    this.overlays.splice(removeIndex,1);
                    this.forceUpdate();
                }
            },(OverlayManager.TRANS_SPEED*1000)+10);
        }
    }

    render() {
        return (
            <>            
                {this.overlays.map(($value, $index)=>{                    
                    return React.createElement(Overlay,{
                        key:$value.id,
                        data:$value
                    });
                })}
            </>
        );
    }
}
